import assignToThis from '../../../helper/assignToThis';

export class ScenarioOpex {
  
  public actualAdministrativeManagementCost: number | null = null;

  public leaseArea: number | null = null;

  public fixedAnnualRentPeriod1: number | null = null;
  public fixedNumberOfYearsPeriod1: number | null = null;

  public variableAnnualRentPeriod1: number | null = null;
  public variableNumberOfYearsPeriod1: number | null = null;

  public purchasePriceOfLand: number | null = null;
  public upfrontRentPayment: number | null = null;

  public omContractWithMargin: number | null = null;
  public omContractWithoutMargin: number | null = null;
  public verifications: number | null = null;
  public networkMeterDeie: number | null = null;
  public electricity: number | null = null;
  public telecom: number | null = null;
  public maintenanceRepairsForRealEstateEquipmentWorks: number | null = null;

  public environmentalChargesYear1: number | null = null;
  public environmentalChargesYear2: number | null = null;
  public environmentalChargesYear3: number | null = null;
  public environmentalChargesYear4: number | null = null;
  public environmentalChargesYear5: number | null = null;
  public environmentalChargesYear6: number | null = null;
  public environmentalChargesYear7: number | null = null;
  public environmentalChargesYear8: number | null = null;
  public environmentalChargesYear9: number | null = null;
  public environmentalChargesYear10: number | null = null;
  public environmentalChargesYear11: number | null = null;
  public environmentalChargesYear12: number | null = null;
  public environmentalChargesYear13: number | null = null;
  public environmentalChargesYear14: number | null = null;
  public environmentalChargesYear15: number | null = null;
  public environmentalChargesYear16: number | null = null;
  public environmentalChargesYear17: number | null = null;
  public environmentalChargesYear18: number | null = null;
  public environmentalChargesYear19: number | null = null;
  public environmentalChargesYear20: number | null = null;
  public environmentalChargesYear21: number | null = null;
  public environmentalChargesYear22: number | null = null;
  public environmentalChargesYear23: number | null = null;
  public environmentalChargesYear24: number | null = null;
  public environmentalChargesYear25: number | null = null;
  public environmentalChargesYear26: number | null = null;
  public environmentalChargesYear27: number | null = null;
  public environmentalChargesYear28: number | null = null;
  public environmentalChargesYear29: number | null = null;
  public environmentalChargesYear30: number | null = null;
  public environmentalChargesYear31: number | null = null;
  public environmentalChargesYear32: number | null = null;
  public environmentalChargesYear33: number | null = null;
  public environmentalChargesYear34: number | null = null;
  public environmentalChargesYear35: number | null = null;

  public otherChargesYear1: number | null = null;
  public otherChargesYear2: number | null = null;
  public otherChargesYear3: number | null = null;
  public otherChargesYear4: number | null = null;
  public otherChargesYear5: number | null = null;
  public otherChargesYear6: number | null = null;
  public otherChargesYear7: number | null = null;
  public otherChargesYear8: number | null = null;
  public otherChargesYear9: number | null = null;
  public otherChargesYear10: number | null = null;
  public otherChargesYear11: number | null = null;
  public otherChargesYear12: number | null = null;
  public otherChargesYear13: number | null = null;
  public otherChargesYear14: number | null = null;
  public otherChargesYear15: number | null = null;
  public otherChargesYear16: number | null = null;
  public otherChargesYear17: number | null = null;
  public otherChargesYear18: number | null = null;
  public otherChargesYear19: number | null = null;
  public otherChargesYear20: number | null = null;
  public otherChargesYear21: number | null = null;
  public otherChargesYear22: number | null = null;
  public otherChargesYear23: number | null = null;
  public otherChargesYear24: number | null = null;
  public otherChargesYear25: number | null = null;
  public otherChargesYear26: number | null = null;
  public otherChargesYear27: number | null = null;
  public otherChargesYear28: number | null = null;
  public otherChargesYear29: number | null = null;
  public otherChargesYear30: number | null = null;
  public otherChargesYear31: number | null = null;
  public otherChargesYear32: number | null = null;
  public otherChargesYear33: number | null = null;
  public otherChargesYear34: number | null = null;
  public otherChargesYear35: number | null = null;

  public omTurbineDurationPeriod1: number | null = null;
  public omTurbineDurationPeriod2: number | null = null;
  public omTurbineDurationPeriod3: number | null = null;
  public omTurbineDurationPeriod4: number | null = null;
  public omTurbineDurationPeriod5: number | null = null;
  public omTurbineDurationPeriod6: number | null = null;

  public omTurbineFixedPricePeriod1: number | null = null;
  public omTurbineFixedPricePeriod2: number | null = null;
  public omTurbineFixedPricePeriod3: number | null = null;
  public omTurbineFixedPricePeriod4: number | null = null;
  public omTurbineFixedPricePeriod5: number | null = null;
  public omTurbineFixedPricePeriod6: number | null = null;

  public omTurbineVariablePricePeriod1: number | null = null;
  public omTurbineVariablePricePeriod2: number | null = null;
  public omTurbineVariablePricePeriod3: number | null = null;
  public omTurbineVariablePricePeriod4: number | null = null;
  public omTurbineVariablePricePeriod5: number | null = null;
  public omTurbineVariablePricePeriod6: number | null = null;

  public omTurbineMinimumVariablePricePeriod1: number | null = null;
  public omTurbineMinimumVariablePricePeriod2: number | null = null;
  public omTurbineMinimumVariablePricePeriod3: number | null = null;
  public omTurbineMinimumVariablePricePeriod4: number | null = null;
  public omTurbineMinimumVariablePricePeriod5: number | null = null;
  public omTurbineMinimumVariablePricePeriod6: number | null = null;

  public municipalRate: number | null = null;
  public departmentalRate: number | null = null;

  public municipalRateCFE: number | null = null;
  public interMunicipalRateCFE: number | null = null;
  public coefficientDeNeutralisationCFE: number | null = null;

  public municipalRatePropertyTax: number | null = null;
  public interMunicipalRatePropertyTax: number | null = null;
  public coefficientDeNeutralisationTF: number | null = null;

  public constructor(obj: object = {}) {
    assignToThis(this, obj);

  }

}
